import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {DatePipe} from '@angular/common';
import {iif, Observable, of} from 'rxjs';
import {switchMap, take, tap} from 'rxjs/operators';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BasicPersonDetailDTO} from '../../../../ent/models/person/BasicPersonDetailDTO';
import {PolicyService} from '../../../../ent/services/policy.service';
import {PolicyDTO} from '../../../../ent/models/PolicyDTO';
import {DateUtil} from '../../../util/DateUtil';
import {ProcessingClass} from '../../../../clm/types/processing-class.enum';
import {PolicyholderGroupService} from '../../../../ent/services/policyholder-group.service';
import {PolicyholderGroupDTO} from '../../../../ent/models/PolicyholderGroupDTO';

@Component({
  selector: 'app-policy-overview',
  templateUrl: './policy-overview.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss', './policy-overview.component.scss']
})
export class PolicyOverviewComponent implements OnInit {
  readonly dateFormat = DateUtil.dateFormat;

  @Output() policyIdValue: EventEmitter<number> = new EventEmitter<number>();
  @Output() policyholderGroupIdValue: EventEmitter<number> = new EventEmitter<number>();
  @Output() policyNumber: EventEmitter<string> = new EventEmitter<string>();
  
  policyDTO: PolicyDTO;
  policyholderGroupDTO: PolicyholderGroupDTO;
  policyProductPersonLinksDisplayedColumns: string[] = [
    'personName',
    'nationalIdNumber',
    'memberAssociation',
    'product',
    'startAndEndDate',
  ];

  constructor(
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<PolicyOverviewComponent>,
    private policyService: PolicyService,
    private policyholderGroupService: PolicyholderGroupService,
    @Inject(MAT_DIALOG_DATA) public basicPersonDetailDTO: BasicPersonDetailDTO
  ) {
  }

  ngOnInit(): void {

    if (this.basicPersonDetailDTO.personId) {
      this.getPolicyByInsuredPersonId(this.basicPersonDetailDTO.personId, ProcessingClass.Medical)
        .pipe(
          tap(policyDTO => {
            this.policyDTO = policyDTO;
            this.policyNumber.emit(policyDTO?.number);
            this.policyIdValue.emit(policyDTO?.policyId);
          }),
        )
        .pipe(
          switchMap(_ => {
            const policyHolderGroupValue = this.policyDTO?.policyholderGroup?.value;
            return iif(
              () => !!policyHolderGroupValue,
              this.policyholderGroupService.getPolicyholderGroup(policyHolderGroupValue),
              of(null));
          }),
          take(1)
        )
        .pipe(tap((policyholderGroup: PolicyholderGroupDTO) => {
          this.policyholderGroupDTO = policyholderGroup;
          this.policyholderGroupIdValue.emit(policyholderGroup?.policyholderGroupId);
        }))
        .subscribe();
    }
  }


  getPolicyByInsuredPersonId(personId: number, processingClassId: number): Observable<PolicyDTO> {
    return this.policyService.getPolicyBy(personId, processingClassId)
      .pipe(
        take(1),
      );
  }

  getPersonFullName(person): string {
    const middleName = person.middleName ? person.middleName : '';
    return `${person.firstName} ${middleName} ${person.lastName}`;
  }

  getStartAndEndDate(startDate, endDate): string {
    return `${this.datePipe.transform(startDate, this.dateFormat)} - ${endDate != null ? this.datePipe.transform(endDate, this.dateFormat) : 'current'} `;
  }

}
